// ConnectionManager - Catchphrase
export const CloseCodes = {
    // --- Standard WebSocket / Colyseus layer ---
    1001: { displayMessage: "Browser Tab Closing", retryable: false },
    1002: { displayMessage: "Malformed frame received", retryable: false },
    1003: { displayMessage: "Unsupported frame received", retryable: false },
    1006: { displayMessage: "Ungraceful shutdown / connection refused", retryable: true, retryDelay: 2500 },
    1011: { displayMessage: "Internal Error", retryable: false },
    1012: { displayMessage: "Server Restarting", retryable: true, retryDelay: 4000 },
    1013: { displayMessage: "Try again later, server capacity full", retryable: true, retryDelay: 5000 },
    1014: { displayMessage: "Bad Gateway", retryable: true, retryDelay: 4000 },
    // --- Colyseus 0.17 CloseCode range (4000-4010 reserved by the framework) ---
    4000: { displayMessage: "Left the game", retryable: false },                                  // CONSENTED
    4001: { displayMessage: "Server restarting", retryable: true, retryDelay: 4000 },             // SERVER_SHUTDOWN
    4002: { displayMessage: "Disconnected due to a server error", retryable: false },             // WITH_ERROR
    4003: { displayMessage: "Reconnection failed", retryable: false },                            // FAILED_TO_RECONNECT
    4004: { displayMessage: "Disconnected due to no Host when connection established, force closing room.", retryable: false },
    4005: { displayMessage: "Disconnected due to no Host when client left, force closing room.", retryable: false },
    4010: { displayMessage: "Connection interrupted", retryable: true, retryDelay: 1500 },        // MAY_TRY_RECONNECT
    4050: { displayMessage: "Player removed", retryable: false },
};

const DEFAULT_REASON = "Oops! Looks like something went wrong.";

export function isTerminalByCode(code) {
    return !CloseCodes[code]?.retryable;
}

export function retryDelayForCode(code) {
    return CloseCodes[code]?.retryDelay || 2000;
}

export function getCloseReasonText(code, fallbackMsg) {
    if (CloseCodes[code]?.displayMessage) return CloseCodes[code].displayMessage;
    return fallbackMsg || DEFAULT_REASON;
}

export function isTerminalReconnectError(err) {
    if (err instanceof ProgressEvent && err.type === "error") {
        return true;
    }
    const msg = `${err?.message || ""}`.toLowerCase();
    if (/err_connection_refused|connection\s*refused|econnrefused/.test(msg)) {
        return true;
    }
    return /not\s*found|room\s*not\s*found|disposed|room\s*disposed|expired|reconnection\s*token|invalid\s*room|invalid\s*reconnection|closed\s*room/.test(msg);
}
